import React, { useState, useEffect } from 'react';
import '../App.css';
import axios from "axios";
import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
//import Navbar from "./Navbar_vecchio";
import { useAuth0 } from "@auth0/auth0-react";
import Menu_generale_ditte from "./Ditta_x7_menu_generale.jsx";
import Lista_ditte from "./Ditta_x5_lista_ditte.jsx";
import JSONPretty from 'react-json-pretty';
import { CiSearch } from "react-icons/ci";
import { IoReturnDownBackSharp } from "react-icons/io5"


// chiamare una funzione comune
const { Tipologia_Aziende } = require('../Funzioni_comuni_tipologia_aziende')

function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }


const Nuova_Ditta = (props) => {
   
    const [input_tipologia, SET_input_tipologia] = useState({});
    const [cestino, SET_cestino] = useState(false);
    const { user, isAuthenticated } = useAuth0();

    
    const [variab_aggiorna, SET_variab_aggiorna] = useState(false);

    const [lista_ditte, SET_lista_ditte] = useState([]);
    const [tutor, SET_tutor] = useState();
    const [ricerca_ditta, SET_ricerca_ditta] = useState(false);
  

    useEffect(() => {
        Controlla_se_esiste_Account()

      
        
    }, [variab_aggiorna, user]);

  
    useEffect(() => {

        if (!ricerca_ditta) {
            Carica_ditte_x_account(cestino)
                       
        }
//    Carica_ditte_x_account()
        
    }, [input_tipologia, ricerca_ditta]);


    const Controlla_se_esiste_Account = () => {
        //    funzione_set_aggiornamento(true)
        console.log('XXXXXXXXXXXXXXX Carica_tutor_x_account')
        let email_google = check_variabili_oggetto (user, 'email')  
//        console.log(check_variabili_oggetto (user, 'email'))
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        axios.get('/tutor/cerca1/' + email_google)
            .then((res) => {
                console.log('un TUTOR appena fecciato da mongo')
                console.log(res.data)
                SET_tutor(res.data[0])
//                console.log(check_variabili_oggetto (res.data[0], '_id'))
                if (Array.isArray(res.data) && res.data.length > 0) 
                    {
                        //Carica_ditte_x_account()
                        console.log(res.data.array_tipologia_azienda)
                        let array_oggetti_tipologie = {}  
                        res.data[0].array_tipologia_azienda.map((item, index) => {
                            array_oggetti_tipologie[item] = true
//                            console.log(array_oggetti_tipologie);
                        })
                        SET_input_tipologia(prevInput => {
                            return {
                                ... array_oggetti_tipologie
                            }
                        })
//                          
                    }  
            }).catch((error) => {
                console.log(error)
            });
    }


    const Carica_ditte_x_account = (variabile_cestino) => {
        //    funzione_set_aggiornamento(true)
        const lista_tipologia_aziende = Tipologia_Aziende()
         
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
//        console.log('input_tipologia' + input_tipologia)
//        console.log(input_tipologia)
        const lista_pura_senza_oggetti = Object.keys(input_tipologia).filter(k => input_tipologia[k] === true);
//        console.log(lista_pura_senza_oggetti)
//        console.log(lista_tipologia_aziende)
        const lista_tipologia_stornate = lista_tipologia_aziende.filter( function( el ) {
            return lista_pura_senza_oggetti.indexOf( el ) < 0;
        } );
//        console.log(lista_tipologia_stornate)
        console.log('Carica ditte_x_account')
        console.log(tutor)    
        console.log('variabile_cestino ' + variabile_cestino)    

        if (tutor != undefined) {
        axios.get('/ditte/ditte_carica_tutti/' , {
            params: {
                utente: utente,
                lista_tipologia_stornate: JSON.stringify(lista_tipologia_stornate),
                email: user.email,
                cestino: variabile_cestino
            }
        }).then((res) => {
//                console.log('domande appena fecciate da mongo')
//                console.log(res.data)
                SET_lista_ditte(res.data)
            }).catch((error) => {
                console.log(error)
            });
        }
    }


    function handleChange(event) {
        const { name, value, type } = event.target;
        console.log('cestino attuale: ' + cestino)
        Carica_ditte_x_account(!cestino)
        

        SET_cestino(current => !current)
    }
        


    return (
    <>
    <div className='container d-flex flex-row-reverse'>
       
        {(props.account_dati.utente_debug) &&
            <>
            <JSONPretty data={user} />
        
            <JSONPretty data={tutor} />
            </>
        }

        {/* idroslab  utilizzo del form di bootstrap*/}

        {user != undefined && user.email === 'paolosordi12@gmail.com' && <Form.Check // prettier-ignore
                    type='checkbox'
                    name='Cestino' 
                    onChange={handleChange}  
                    checked = {cestino}                  
                    label={`Visualizza ditte nel cestino`}
                />}
        {/*console.log(lista_ditte)*/}
    </div>

    <div className='container d-flex justify-content-between'>
       
        <div>
            {tutor != undefined && <Menu_generale_ditte boolean_lista_ditte = {lista_ditte.length === 0} input_tipologia={input_tipologia} SET_input_tipologia={SET_input_tipologia} 
                                  SET_variab_aggiorna={SET_variab_aggiorna} tutor={tutor} SET_ricerca_ditta={SET_ricerca_ditta} ricerca_ditta={ricerca_ditta}
                                  variab_aggiorna= {variab_aggiorna}
                                  SET_lista_ditte={SET_lista_ditte} />}
          
        </div>
        
        <div className='d-flex flex-column flex-grow'>
            
        {ricerca_ditta && <>
            <div className='d-flex flex-row justify-content-between'>
      {/* idroslab  size di una icona*/}
            <Button onClick={() => SET_ricerca_ditta(false)} disabled={false} 
              className=""> <IoReturnDownBackSharp size={40}/> Ritorna </Button> 
            <CiSearch size={70} />
            </div>
            
        </>}

            {lista_ditte.length === 0  && <h1>Utente non riconosciuto</h1> } 
           
             <Lista_ditte tutor={tutor} lista_ditte={lista_ditte} account_dati={props.account_dati} 
                          variab_aggiorna={variab_aggiorna} 
                          SET_variab_aggiorna={SET_variab_aggiorna} 
                          SET_ricerca_ditta={SET_ricerca_ditta} ricerca_ditta={ricerca_ditta}/>
    
        </div>

            
    </div>
    </>
    )
}

export default Nuova_Ditta;
